import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { EditableProperty } from './EditableProperty';

/*
using:
<EditableEventProperty patchField="phoneNumber"/>
 */
export const EditableSequentialNumberProperty = ({
  entity,
  sequentialNumberType,
  handleChange,
  preChange,
  patchField,
  placeholder,
  editFormatter,
  labelFormatter,
  name,
  ...rest
}) => (
  <EditableProperty
    dto={entity}
    changeHandler={handleChange}
    preChange={preChange}
    patchField={patchField}
    placeholder={placeholder}
    targetUrl={`${process.env.REACT_APP_DOCUMENT_SERVICE_URL}/sequentialNumbers/${sequentialNumberType}`}
    editFormatter={editFormatter}
    labelFormatter={labelFormatter}
    name={name}
    {...rest}
  />
);

EditableSequentialNumberProperty.propTypes = {
  patchField: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  editFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
  labelFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
  preChange: PropTypes.func,
};
